import { useEffect } from "react";

/**
 * Inject (and later remove) a JSON-LD structured-data <script> into
 * document.head. Search engines (Google, Bing, Yandex) read this for
 * rich results. One script tag is rendered per `id`.
 *
 * Usage: useJsonLd("article-schema", { "@context":"https://schema.org", "@type":"Article", ... })
 */
export default function useJsonLd(id, data) {
  useEffect(() => {
    if (!data || !id) return undefined;
    const scriptId = `jsonld-${id}`;
    let node = document.getElementById(scriptId);
    if (!node) {
      node = document.createElement("script");
      node.type = "application/ld+json";
      node.id = scriptId;
      document.head.appendChild(node);
    }
    try {
      node.textContent = JSON.stringify(data);
    } catch {
      /* ignore */
    }
    return () => {
      const n = document.getElementById(scriptId);
      if (n?.parentNode) n.parentNode.removeChild(n);
    };
  }, [id, data]);
}
